module.exports = __webpack_public_path__ + "eadb39818ae3dc735597f98f88d9db6e.fbx";